import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { appointmentQKeys } from "@hooks/queries/appointment/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


interface MutationProps {
  id: string;
  date: Date;
  quantity: number;
}

export const useUpdateAppointmentSlot = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: ({ id, date, quantity }: MutationProps) => {
      return api.patch(`appointments/v-slots/${id}`, {
        start_time: date.toISOString(),
        quantity,
      });
    },
    onSuccess: () => {
      showSuccessNotification({ message: "update-appointment-slot-success" });
      queryClient.invalidateQueries({ queryKey: appointmentQKeys.slots() }); // Only need this because this and slotsWithFilters will need to be invalidated
    },

    onError: (res: any) => {
      console.error("[From Update Appointment Slot]", res);
      queryClient.invalidateQueries({ queryKey: appointmentQKeys.slots() });

      handleErrors(res, "mutation");
    },
  });
};
